import ApiService from "./base";
import { config } from "@/utils/config";
export default class OrganizationService extends ApiService {
    constructor(){
        super({
            baseURL: config.apiUrl
        });
    }
    async getOrganizationUsers(role, customerId) {
        const params = new URLSearchParams();
        if (role) params.append('role', role);
        if (customerId) params.append('customerId', customerId);
        const url = `/direct/organization/users${params.toString() ? `?${params.toString()}` : ''}`;
        const response = await this.get({
            url
        });
        return response.data;
    }
    async addUser(data) {
        const response = await this.post({
            url: `/direct/organization/users`,
            data
        });
        return response.data;
    }
    async deleteUser(userId) {
        const response = await this.delete({
            url: `/direct/organization/users/${userId}`
        });
        return response.data;
    }
    async getAllOrganizations() {
        const response = await this.get({
            url: '/direct/organization/all'
        });
        return response.data;
    }
    async updateOrganizationName(name) {
        const response = await this.patch({
            url: '/direct/organization/name',
            data: {
                name
            }
        });
        return response.data;
    }
    async getOrganizationSettings() {
        const response = await this.get({
            url: '/direct/organization/settings'
        });
        return response.data;
    }
    async updateOrganizationSettings(settings) {
        const response = await this.patch({
            url: '/direct/organization/settings',
            data: settings
        });
        return response.data;
    }
}
